import React from 'react';

const Header = (props) => {
	return (
		<div className='fixed-header'>
			{
				props.children
			}
		</div>
	);
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js